var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseFill = function SvgCloseFill(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.319 4.681c-6.241-6.241-16.396-6.242-22.638 0s-6.241 16.396 0 22.638 16.396 6.242 22.638 0c6.241-6.242 6.241-16.397 0-22.638zM22.312 22.312c-0.481 0.481-1.26 0.481-1.741 0l-4.571-4.571-4.789 4.789c-0.481 0.481-1.26 0.481-1.741 0s-0.481-1.26 0-1.741l4.789-4.789-4.571-4.571c-0.481-0.481-0.481-1.261 0-1.741s1.26-0.481 1.741 0l4.571 4.571 4.353-4.353c0.481-0.481 1.26-0.481 1.741 0s0.481 1.26 0 1.741l-4.353 4.353 4.571 4.571c0.481 0.481 0.481 1.26 0 1.741z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-fill.acee9308.svg";
export { ForwardRef as ReactComponent };